export default async function ({ app, store }) {
  store.dispatch("application/renewCancelToken");
  await store.dispatch("authentication/nuxtClientInit", app.router);
}
